module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tools-tab tools-tab-shift"
  }, [_c('ul', {
    staticClass: "list list-shifts"
  }, _vm._l((_vm.activeShifts), function(shift) {
    return _c('li', {
      class: [_vm.hasShift(shift) ? 'is-active' : ''],
      on: {
        "click": function($event) {
          return _vm.select(shift)
        }
      }
    }, [_c('em', [_vm._v(_vm._s(shift.identifier))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(shift.name))]), _vm._v(" "), (_vm.hasShift(shift)) ? _c('icon', {
      attrs: {
        "name": "delete"
      }
    }) : _c('icon', {
      attrs: {
        "name": "add"
      }
    })], 1)
  }), 0), _vm._v(" "), (!_vm.shifts.length) ? _c('div', {
    staticClass: "empty"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('page.settings.shifts.empty')) + "\n    ")]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5da6b2bf","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/global/tools/Shift.vue
// module id = 593
// module chunks = 225